import { render, staticRenderFns } from "./modalDegustacaoServico.vue?vue&type=template&id=30ef9bc8&scoped=true&"
import script from "./modalDegustacaoServico.vue?vue&type=script&lang=js&"
export * from "./modalDegustacaoServico.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=30ef9bc8&scoped=true&lang=css&"
import style1 from "./modalDegustacaoServico.vue?vue&type=style&index=1&id=30ef9bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef9bc8",
  null
  
)

export default component.exports